import { getCookie } from '../common/utils/cookie';

export function telephonyEnabled({ telephony, inPersonTelephony }) {
  if (telephony) {
    return true;
  }
  if (inPersonTelephony) {
    const meetType = getCookie('meetType');
    if (['inPerson', 'telephonicThreeWay'].includes(meetType)) {
      return true;
    }
  }
  return false;
}

export function injectTelephonyRouting(config) {
  const telephonySection = {
    navTitle: 'Telephony',
    route: '/telephony',
    noSideNav: true,
    pages: [
      {
        title: 'Prepare',
        navTitle: 'Prepare',
        route: '/prepare',
        settings: {},
        fields: [],
      },
      {
        title: 'Call',
        navTitle: 'Call',
        route: '/call',
        settings: {},
        fields: [],
      },
    ],
  };
  return { ...config, form: [ telephonySection, ...config.form ] };
}
